module.exports = __webpack_public_path__ + "static/media/galerija_2021 (29).3b18a35e.jpg";